module.exports = __webpack_public_path__ + "img/cptgb-2.ee70bcc4.png";